const pino = require('pino')

const logger = pino({
  level: process.env.APP_ENV === 'prod' ? 'info' : 'trace',
  timestamp: pino.stdTimeFunctions.isoTime,
})

const createHandler = (clientSide) => ({
  get: (target, name) => {
    if (['trace', 'debug', 'info', 'warn', 'error', 'fatal'].includes(name)) {
      return (data) => {
        if (typeof data === 'object') {
          target[name].call(target, { ...data, clientSide })
        } else {
          target[name].call(target, data)
        }
      }
    } else {
      return target[name]
    }
  },
})

const clientLogger = new Proxy(logger, createHandler(true))
const serverLogger = new Proxy(logger, createHandler(false))

module.exports = {
  ...serverLogger,
  client: clientLogger,
}
